import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AiGetParams, AiList, AiQuestion } from './ai.model';

@Injectable({
  providedIn: 'root'
})
export class AiService {
  readonly #http = inject(HttpClient);
  readonly #aiUrl = `${environment.authHost}/api/question/`;

  createQuestion(question: string) {
    return this.#http.post<AiQuestion>(`${this.#aiUrl}/create/`, { question });
  }

  getQuestion(questionId: number) {
    return this.#http.get<AiQuestion>(`${this.#aiUrl}/question/${questionId}/`);
  }

  getQuestions({ query, limit, offset }: AiGetParams) {
    return this.#http.get<AiList>(this.#aiUrl, {
      params: {
        ...(query ? { query } : {}),
        limit,
        offset
      }
    });
  }

  deleteQuestion(questionId: number) {
    return this.#http.delete(`${this.#aiUrl}/question/${questionId}/`);
  }
}
